import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	dragAndDropSchedule: {
		id: 'eoc-schedule.ui.list.schedule.header.drag-and-drop-schedule',
		defaultMessage: 'Drag and drop your schedule',
		description: 'An icon for dragging and dropping a schedule to change order.',
	},
	moreActionsForSchedule: {
		id: 'eoc-schedule.ui.list.schedule.header.more-actions-for-schedule',
		defaultMessage: 'More actions for schedule {scheduleName}',
		description: 'Schedule settings button.',
	},
	export: {
		id: 'eoc-schedule.ui.list.schedule.header.export',
		defaultMessage: 'Export',
		description: 'Button for exporting schedule.',
	},
	collapse: {
		id: 'eoc-schedule.ui.list.schedule.header.collapse',
		defaultMessage: 'Collapse',
		description: 'Label of collapse button',
	},
	expand: {
		id: 'eoc-schedule.ui.list.schedule.header.expand',
		defaultMessage: 'Expand',
		description: 'Label of expand button',
	},
});
